import React from "react";
import { useIntl } from "react-intl";
import { messages } from "../Delivery.messages";
import styles from "./Slides.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { nl2p } from "@src/utils/nl2p";
import { useUi } from "@jelly/lesson";

import { ExportModal, BussesModal, RoutingModal, DolbyModal, AdmModal } from "../Modals/Modals";

interface SlideProps {}

export const Slide1: React.FC<SlideProps> = () => {
  const { formatMessage } = useIntl();
  const { Button } = useUi();

  // Modal state management
  const [exportModalOpen, setExportModalOpen] = React.useState(false);

  const handleCloseExportModal = React.useCallback(() => setExportModalOpen(false), []);

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          <div className={styles.oneColumn}>
            <h3>{formatMessage(messages.G2_P5_S1_Title)}</h3>
            {nl2p(formatMessage(messages.G2_P5_S1_Description))}

            {formatMessage(messages.G2_P5_S1_L1_Title)}
            <ul>
              <li>{formatMessage(messages.G2_P5_S1_L1_Item1)}</li>
              <li>{formatMessage(messages.G2_P5_S1_L1_Item2)}</li>
            </ul>

            <div className={styles.centeredButton}>
              <Button
                size={"small"}
                theme={"primary"}
                shape={"round"}
                icon={"cil-library-add"}
                onClick={() => setExportModalOpen(true)}
              >
                {formatMessage(messages.G2_P5_S1_P1_ButtonLabel)}
              </Button>
            </div>
          </div>
        </div>

        {/* Modals */}
        <ExportModal visible={exportModalOpen} onClose={handleCloseExportModal} />
      </div>
    </SimpleLayoutView>
  );
};

export const Slide2: React.FC<SlideProps> = () => {
  const { formatMessage } = useIntl();
  const { Button } = useUi();

  // Modal state management
  const [bussesModalOpen, setBussesModalOpen] = React.useState(false);
  const [routingModalOpen, setRoutingModalOpen] = React.useState(false);
  const [dolbyModalOpen, setDolbyModalOpen] = React.useState(false);
  const [admModalOpen, setAdmModalOpen] = React.useState(false);

  const handleCloseBussesModal = React.useCallback(() => setBussesModalOpen(false), []);
  const handleCloseRoutingModal = React.useCallback(() => setRoutingModalOpen(false), []);
  const handleCloseDolbyModal = React.useCallback(() => setDolbyModalOpen(false), []);
  const handleCloseAdmModal = React.useCallback(() => setAdmModalOpen(false), []);

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          <div className={styles.oneColumn}>
            <h3>{formatMessage(messages.G2_P5_S2_Title)}</h3>
            {nl2p(formatMessage(messages.G2_P5_S2_Description))}

            <div className={styles.buttonGroup}>
              <Button
                size={"small"}
                theme={"primary"}
                shape={"round"}
                icon={"cil-equalizer"}
                onClick={() => setBussesModalOpen(true)}
              >
                {formatMessage(messages.G2_P5_S2_P1_ButtonLabel1)}
              </Button>
              <Button
                size={"small"}
                theme={"primary"}
                shape={"round"}
                icon={"cil-random"}
                onClick={() => setRoutingModalOpen(true)}
              >
                {formatMessage(messages.G2_P5_S2_P1_ButtonLabel2)}
              </Button>
              <Button
                size={"small"}
                theme={"primary"}
                shape={"round"}
                icon={"cil-settings"}
                onClick={() => setDolbyModalOpen(true)}
              >
                {formatMessage(messages.G2_P5_S2_P1_ButtonLabel3)}
              </Button>
              <Button
                size={"small"}
                theme={"primary"}
                shape={"round"}
                icon={"cil-external-link"}
                onClick={() => setAdmModalOpen(true)}
              >
                {formatMessage(messages.G2_P5_S2_P1_ButtonLabel4)}
              </Button>
            </div>
          </div>
        </div>

        {/* Modals */}
        <BussesModal visible={bussesModalOpen} onClose={handleCloseBussesModal} />
        <RoutingModal visible={routingModalOpen} onClose={handleCloseRoutingModal} />
        <DolbyModal visible={dolbyModalOpen} onClose={handleCloseDolbyModal} />
        <AdmModal visible={admModalOpen} onClose={handleCloseAdmModal} />
      </div>
    </SimpleLayoutView>
  );
};

export const Slide3: React.FC<SlideProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          <div className={styles.oneColumn}>
            <h3>{formatMessage(messages.G2_P5_S3_Title)}</h3>
            {nl2p(formatMessage(messages.G2_P5_S3_Description))}
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
